import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import classNames from 'classnames';
import { IS_EDGE } from '../../../helpers/BrowserHelpers';
export default function TableWrapper(_ref) {
  var table = _ref.table,
      children = _ref.children;
  var wrapperRef = React.useRef();
  var timeoutRef = React.useRef(null);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hasLeftShadow = _React$useState2[0],
      setHasLeftShadow = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hasRightShadow = _React$useState4[0],
      setHasRightShadow = _React$useState4[1];

  var onScroll = React.useCallback(function () {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(function () {
      var _wrapperRef$current = wrapperRef.current,
          scrollLeft = _wrapperRef$current.scrollLeft,
          scrollWidth = _wrapperRef$current.scrollWidth,
          clientWidth = _wrapperRef$current.clientWidth;
      setHasLeftShadow(scrollLeft > 0);
      setHasRightShadow(scrollWidth - scrollLeft - 1 > clientWidth);
    }, 0);
    return function () {
      return clearTimeout(timeoutRef.current);
    };
  }, [wrapperRef, setHasLeftShadow, setHasRightShadow]);
  React.useLayoutEffect(function () {
    return onScroll();
  }, [onScroll, table]);
  return React.createElement("div", {
    ref: wrapperRef,
    className: classNames('slite-editor-table-wrapper', {
      'has-left-shadow': hasLeftShadow,
      'has-right-shadow': hasRightShadow,
      'is-edge': IS_EDGE
    }),
    onScroll: onScroll
  }, React.createElement("div", {
    className: "slite-editor-table-shadow background-white left",
    contentEditable: false
  }), children, React.createElement("div", {
    className: "slite-editor-table-shadow background-white right",
    contentEditable: false
  }));
}